import Vue from 'vue'

const state = Vue.observable({
  pagerCount: 7
})

function updatePagerCount() {
  const w = window.innerWidth
  if (w < 400) state.pagerCount = 3
  else if (w < 768) state.pagerCount = 5
  else state.pagerCount = 7
}

updatePagerCount()
window.addEventListener('resize', updatePagerCount)

export default {
  install(Vue) {
    Vue.prototype.$pagerCount = () => state.pagerCount
  }
}
